import * as m from 'motion/react-m';
import { MouseEvent as ReactMouseEvent } from 'react';
import { cn, IconButton } from '../..';
import { SvgIcon } from '../icon/icon';

type ScrollChevronButtonProps = {
  icon: SvgIcon;
  onClick: (e: ReactMouseEvent<HTMLButtonElement>) => void;
  isScrolledToEdge: boolean;
  className?: string;
};
export const ScrollChevronButton = ({
  icon,
  onClick,
  isScrolledToEdge,
  className,
}: ScrollChevronButtonProps) => (
  <m.div
    animate={{ opacity: isScrolledToEdge ? 0 : 1 }}
    className={cn(
      'absolute top-1/2 -translate-y-1/2',
      isScrolledToEdge && 'pointer-events-none',
      className,
    )}>
    <IconButton
      size="sm"
      variant="outline"
      icon={icon}
      className="opacity-0 transition-opacity group-hover:opacity-100"
      onClick={onClick}
    />
  </m.div>
);
